<!--
  (compare w/ src/pages/admin/Dashboard.vue)
-->
<template>
  <main-layout
    margin-top="14px"
    wide
  >
    <integrated v-if="isIntegrated" />
    <non-integrated v-else />
  </main-layout>
</template>
<script>
import integrable from '@/components/mixins/integrable';
import Integrated from './Integrated';
import NonIntegrated from './NonIntegrated';

export default {
  components: {
    Integrated,
    NonIntegrated,
  },
  mixins: [integrable],
};
</script>
